import { useEffect, useState } from "react";
import { useProfile } from "../contexts/ProfileContext";
import { useIdps } from "../contexts/IdpsContext";
import { useHistory } from "react-router-dom";
import { getApplicationState, setApplicationState, START_LINK_IDP } from "../services/common";
import { Button, Container, Row, TextButton } from "../components/common";
import { CBBody, CBHeader, CBAction, CBTextBox, ContentBox } from "../components/common/ContentBox";
import PersonalIcon from '../../images/icon_personal.png';
import SocialIcon from '../../images/icon_social.png';
import FacebookIcon from '../../images/link_facebook.png';
import LinkedInIcon from '../../images/link_link.png';
import GoogleIcon from '../../images/link_google.png';
import AppleIcon from '../../images/link_apple.png';
// import IamSmartIcon from '../../images/iamsmart-dark.png';
import IamSmartIcon from '../../images/link_iamsmart.png';
import LoadingBar from "../components/common/LoadingBar";
import { updateUserProfile } from "../services/api/profileApi";
import { runApi } from "../services/api/ApiContext";
import { toast } from "react-toastify";
import { getAppConfig } from "../services/api/appconfigApi";


// https://www.iamsmart.gov.hk/en/
const idpsOrder = [
	{ name: 'smart', path: '/auth/iamsmart/login', label: 'iAM Smart', icon: IamSmartIcon, unlinkable: false },
	{ name: 'facebook', path: '/auth/facebook/login', label: 'Facebook', icon: FacebookIcon, unlinkable: true },
	{ name: 'linkedin', path: '/auth/linkedin/login', label: 'Linkedin', icon: LinkedInIcon, unlinkable: true },
	{ name: 'google', path: '/auth/google/login', label: 'Google', icon: GoogleIcon, unlinkable: true },
	{ name: 'apple', path: '/auth/apple/login', label: 'Apple', icon: AppleIcon, unlinkable: true },
];

const reorderIdps = (idps) => {
	if (!idps) {
		return idps;
	}

	return idpsOrder
		.map(({ name, icon, label, unlinkable }) => {
			const p = new RegExp(name, 'gi');

			for (const idp of idps) {
				if (p.test(idp.name)) {
					return { ...idp, icon, label, unlinkable };
				}
			}

			return null;
		}).filter((idp) => !!idp);
}

const SocialButton = ({ idp, onLink, onUnlink }) => (
	<div className="btn-social">
		<label>
			{idp?.linked && idp?.unlinkable && (<TextButton onClick={() => onUnlink(idp)}>Unlink</TextButton>)}
			{idp?.linked && !idp?.unlinkable && (<span>Linked</span>)}
		</label>
		{/*{idp.label === "iAM Smart" ?*/}
		{/*    <button className="iamsmart-dark" disabled={idp.linked} onClick={() => onLink(idp)}>*/}
		{/*        <img src={idp.icon} alt={idp.label}/>*/}
		{/*        <span className="iamsmart-buttontext">Login with iAM Smart*/}
		{/*        </span>*/}
		{/*    </button>*/}
		{/*    :*/}
		<Button disabled={idp.linked} onClick={() => onLink(idp)}>
			<img src={idp.icon} alt={idp.label} />
		</Button>
		{/*}*/}
	</div>
)

const ProfileView = () => {
	const history = useHistory();
	const profileContext = useProfile();
	const idpsContext = useIdps();
	const [editMode, setEditMode] = useState(false);
	const [secondaryEmail, setSecondaryEmail] = useState(null);
	const [uiIdpConfig, setUiIdpConfig] = useState(null);
	const profile = profileContext?.data;

	const idps = reorderIdps(idpsContext?.data);

	// const refresh = () => {
	// 	profileContext.refresh();
	// 	idpsContext.refresh();
	// };
	useEffect(() => {
		async function getAppConfigFromApi () {
			const getAppConfigResponse = await runApi(
				'getAppConfig',
				() => getAppConfig()
			);
			if (getAppConfigResponse?.data?.data) {
				const config = getAppConfigResponse.data.data === 'true';
				setUiIdpConfig(config);
			}
		}
		getAppConfigFromApi();
	}, []);

	const onClickLink = (idp) => {
		let linkUrl = null;

		for (const { name, path } of idpsOrder) {
			const p = new RegExp(name, 'gi');

			if (p.test(idp.name)) {
				linkUrl = path;
			}
		}

		if (linkUrl) {
			const appState = getApplicationState();
			appState.state = START_LINK_IDP;
			appState.link = {
				idpId: idp.id,
				idpName: idp.name,
			};
			setApplicationState(appState);

			history.push(linkUrl);
		}
	};

	const onClickUnlink = (idp) => {
		if (window.confirm('Are you sure you want to unlink this social identity?')) {
			idpsContext.unlinkIdp(idp.id);
		}
	}

	const onClear = (event) => {
		cancelEditMode();
	}

	const onSubmit = async (event) => {
		let new_profile = {}
		new_profile.secondaryEmail = secondaryEmail;
		if (secondaryEmail === profileContext?.data?.secondaryEmail) {
			toast.error("Nothing has been updated");
			cancelEditMode();
			return;
		}
		const updateProfileResponse = await runApi(
			'updateProfile',
			() => updateUserProfile(new_profile)
		);

		profileContext.refresh();
		setEditMode(false);

		if (!updateProfileResponse?.data?.status) {
			return;
		}

		toast.success("Update success");
	}

	const cancelEditMode = () => {
		setSecondaryEmail(profile?.secondaryEmail);
		setEditMode(false);
	}

	const editEvent = () => {
		setEditMode(true)
		setSecondaryEmail(profileContext?.data?.secondaryEmail);
	}

	return (
		<Container>
			<h1>Profile</h1>

			<ContentBox>
				<CBHeader icon={PersonalIcon} title={'Personal information'} showEdit={false}
					editEvent={() => editEvent()} />
				<CBBody>
					<Row>
						<div className="col-lg-4 col-md-12">
							<CBTextBox name={'Electronic ID'} value={profile?.electronicId} disabled />
						</div>
						<div className="col-lg-2 col-md-6">
							<CBTextBox name={'First Name'} value={profile?.firstName} disabled />
						</div>
						<div className="col-lg-2 col-md-6">
							<CBTextBox name={'Last Name'} value={profile?.lastName} disabled />
						</div>
						<div className="col-lg-4 col-md-12">
							<CBTextBox name={'Display name'} value={profile?.displayName} disabled />
						</div>
						<div className="col-lg-4 col-md-12">
							<CBTextBox name={'Primary Email'} value={profile?.primaryEmail} disabled />
						</div>
						<div className="col-lg-4 col-md-12">
							<CBTextBox name={'Recovery Email'} value={editMode ? secondaryEmail : profile?.secondaryEmail} disabled={!editMode}
								onChange={(event) => {
									setSecondaryEmail(event.target.value)
								}} />
						</div>
						<div className="col-lg-4 col-md-12">
							<CBTextBox name={'Job Title'} value={profile?.department} disabled />
						</div>
					</Row>
					{editMode &&
						<CBAction>
							<Button type={'submit'} onClick={(event) => onSubmit(event)}>Save</Button>
							<Button onClick={(event) => onClear(event)}>Cancel</Button>
						</CBAction>
					}
				</CBBody>
			</ContentBox>

			{uiIdpConfig === true && <ContentBox>
				<CBHeader icon={SocialIcon} title={'Social Identities & "IAM SMART"'} />
				<CBBody>
					<p className="red">You may wish to associate your CityU EID with the following authentication system or
						Social Media ID for seamless and secure login. None of your personal information will be transferred away
						from the university.</p>

					<div className="clearfix">
						{
							idps && idps.map((idp) => (
								<SocialButton idp={idp} onLink={onClickLink} onUnlink={onClickUnlink} />
							))
						}
						{
							!idps && (<LoadingBar isLoading={true} />)
						}
					</div>
				</CBBody>
			</ContentBox>}
		</Container>
	);
}

export default ProfileView;
